import {AxiosResponse} from "axios";

import CoreApi from "@/src/modules/core/api";
import {GetListResponse, GetResponse, ParamsOptions} from "@/src/modules/core/types";

import {
  EmergencyContact,
  Property,
  PropertyCitationType,
  PropertyForCreate,
  PropertyForRequest,
  PropertyPool,
  PropertyType,
} from "../types";

class PropertiesApi extends CoreApi {
  async getProperties(options: ParamsOptions): Promise<AxiosResponse<GetListResponse<Property>>> {
    return this.search("property", options);
  }

  async getProperty(id: number): Promise<AxiosResponse<GetResponse<Property>>> {
    return this.getById("property", id);
  }

  async getPropertyTypes(): Promise<AxiosResponse<{property_types: PropertyType[]}>> {
    return this.get("propertytype");
  }

  async getEmergencyContacts(): Promise<AxiosResponse<{contact_telephones: EmergencyContact[]}>> {
    return this.get("contacttelephone");
  }

  async getCitationTypes(): Promise<AxiosResponse<{citation_types: PropertyCitationType[]}>> {
    return this.get("citationtype");
  }

  async createProperty(
    propertyData: PropertyForCreate,
  ): Promise<AxiosResponse<GetResponse<Property>>> {
    return this.create("property", propertyData);
  }

  async updateProperty(
    id: number,
    propertyData: Omit<PropertyForRequest, "id">,
  ): Promise<AxiosResponse<GetResponse<Property>>> {
    return this.update("property", id, propertyData);
  }

  async deleteProperty(id: number): Promise<AxiosResponse<void>> {
    return this.delete("property", id);
  }

  async getPropertyPools(
    options: ParamsOptions,
  ): Promise<AxiosResponse<GetListResponse<PropertyPool>>> {
    return this.search("property_amenities", {
      ...options,
      filter: {
        ...(options.filter ?? {}),
        amenity_type: "pool",
      },
    });
  }
}

export const propertiesApi = new PropertiesApi();
